import styled from '@emotion/styled';
import { typography } from '@landsbankinn/ui';
import React from 'react';
import { SliceWrapper } from './SliceWrapper';

interface IProps {
  copy: React.ReactNode;
  isArticle: boolean;
}

const Copy = styled.div`
  p {
    ${typography.bodyEditorial};
    font-weight: bold;
  }
`;

export const Emphasis = ({ copy, isArticle }: IProps) => {
  return <SliceWrapper left={<Copy>{copy}</Copy>} isArticle={isArticle} />;
};
